<template>
  <el-card class="traver-guide-config"
           :style="bodyStyle"
           shadow="nerver">
    <el-tabs v-model="activeName"
             @tab-click="handleClickTab">
      <!-- POI库 -->
      <el-tab-pane label="POI库"
                   name="first">
        <div>
          <!-- 添加/迹点列表 -->
          <poi-hub-list></poi-hub-list>
        </div>

      </el-tab-pane>
      <!-- 内容标签管理 -->
      <el-tab-pane label="内容标签管理"
                   name="second">
        <div>
          <p style="margin-bottom:20px">当前所有内容标签：</p>
          <!-- 标签 -->
          <el-tag :key="tag.tag_id"
                  v-for="tag in contentTags"
                  closable
                  style="cursor: pointer;"
                  @click="changeTagName(tag)"
                  :disable-transitions="false"
                  @close="handleClose(tag)">
            {{tag.tag_name}}
          </el-tag>
          <!-- 按钮 -->
          <el-input class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm">
          </el-input>
          <el-button v-else
                     class="button-new-tag"
                     size="small"
                     @click="showInput">+ 添 加</el-button>

        </div>
      </el-tab-pane>
      <!-- 迹点分类 -->
      <el-tab-pane label="迹点分类管理"
                   name="third">
        <!-- 选择分类，清空时为添加新分类 -->
        <span>
          <el-select size="mini"
                     style="margin-right:10px"
                     :clearable='true'
                     v-model="selectClassPid"
                     @change="selectRootClass"
                     @clear="resetPid"
                     placeholder="请选择根分类">
            <el-option v-for="item in options"
                       :key="item.class_id"
                       :label="item.class_name"
                       :value="item.class_id">
            </el-option>
          </el-select>
        </span>
        <!-- 添加根类 -->
        <span>
          <el-input v-model="inputRootClass"
                    style="width:20%"
                    size="mini"
                    placeholder="请输入根类名称"></el-input>
          <el-button size="mini"
                     style="margin-left:5px"
                     @click="addTraverRootClass"
                     type="primary">添加根类</el-button>
        </span>
        <!-- 展示已有分类 -->
        <div class="traver-class-list"
             v-for='root,index in this.options'
             :key="index">
          <div>
            {{root.class_name}}:
          </div>
          <el-tag style="margin:5px 5px 0 0;cursor:pointer"
                  @click="changClassName(item)"
                  size="mini"
                  v-for="item,index in root.class_list"
                  :key="index"> {{item.class_name}} </el-tag>
        </div>

      </el-tab-pane>

    </el-tabs>
  </el-card>
</template>
<script>
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
import PoiHubList from '../config/PoiHubList'

export default {
  name: 'traver-guide-config',
  components: {
    PoiHubList,
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      activeName: 'first',
      contentTags: [],
      bodyStyle: `min-height: ${contentHeight}px`,
      // 分类
      inputRootClass: '',
      selectClassPid: '',
      pid: 0,
      options: [],
    }
  },
  mounted() {
    this.getAllContentTag()
    this.getTraverClass()
  },
  methods: {
    handleClickTab() {},
    // 修改标签
    changeTagName(val) {
      this.$prompt('请输入邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          this.$http
            .get(
              `/traver/change_content_tag?tag_id=${val.tag_id}&tag_name=${value}`
            )
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.getAllContentTag()
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消更改',
          })
        })
    },
    // 点击 x 掉标签
    handleClose(tag) {
      this.$http
        .get(`/traver/delete_content_tag?tag_id=${tag.tag_id}`)
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.contentTags.splice(this.contentTags.indexOf(tag), 1)
            this.$message({
              message: errmsg,
              type: 'success',
            })
          } else {
            this.$message({
              message: errmsg,
              type: 'warning',
            })
          }
        })
      //
    },
    // 获取所有标签
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 确认输入标签 或回车键
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        // 发送请求添加标签
        this.$http
          .get(`/traver/add_content_tag?tag_name=${inputValue}`)
          .then((res) => {
            const { errno, errmsg } = res.data
            if (errno == '0') {
              this.contentTags.push(inputValue)
              this.$message({
                message: errmsg,
                type: 'success',
              })
              this.getAllContentTag()
            } else {
              this.$message({
                message: errmsg,
                type: 'warning',
              })
            }
          })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 点击添加按钮
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 添加迹点分类
    addTraverRootClass() {
      this.$http
        .get(
          `/traver/add_traver_class?class_name=${this.inputRootClass}&pid=${this.pid}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.inputRootClass = ''
            // this.selectClassPid = ''
            this.getTraverClass()
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 选择rootclass 时
    selectRootClass(val) {
      this.pid = val
    },
    resetPid() {
      this.pid = 0
    },
    // 修改分类名称
    changClassName(val) {
      console.log(val)
    },
    // 获取分类列表
    getTraverClass() {
      this.$http.get('/traver/get_traver_class').then((res) => {
        if (res.data.errno == '0') {
          this.options = res.data.data
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
  },
}
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.traver-class-list {
  padding: 10px;
  font-size: 15px;
}
</style>